import { createAPI } from '../../common'

export default {
  // 小样列表
  getLists: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0mjtut', 'post', config),
  // 稿件状态下拉选
  getStatusOptions: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0rvfsz0tubuvt0pqujpot',
      'get',
      config,
      vconfig
    ),
  // 最后处理人下拉选
  getUserOptions: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0rvfsz0vtfst0pqujpot',
      'get',
      config,
      vconfig
    ),
  // 稿件刊期选项
  getDateOptions: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0rvfsz0ebuft0pqujpot',
      'get',
      config,
      vconfig
    ),
  // 根据栏目查询对应的版次列表
  getLayouts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0dpmvnot0mbzpvut', 'get', config),
  // 获取actions
  getE5Actions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot', 'get', config, {
      neverLoading: true
    }),
  getE5Logs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60mpht', 'get', config, { neverLoading: true }),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 调栏栏目树查询
  getAdjustColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bekvtu0dpmvnot', 'get', config),
  // 送制作
  putMake: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0qipup0nblf', 'put', config),
  // 撤销制作
  putUnmake: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0qipup0vonblf', 'put', config),
  // 小样解锁
  putUnlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0vompdl', 'put', config),
  // 剩稿回退
  putRestore: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0sftupsf', 'put', config),
  // 撤签
  putWithdrawal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0xjuiesbxbm', 'put', config),
  // 签发
  putSign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0tjho', 'put', config),
  // 提交组版
  putSubmit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0mbzpvu0tvcnju', 'put', config),
  // 调栏
  putAdjust: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0dpmvnot0bekvtu', 'put', config),
  // 下载
  putDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0epxompbe', 'put', config, {
      timeout: 900000
    }),
  // 获取小样图片地址
  getPhotosPath: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0qipupt0qbui', 'get', config, {
      timeout: 200000
    }),
  // 打印
  putPrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0qsjou', 'put', config),
  // 排序
  putSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0tpsu', 'put', config),
  // 小样导出版次选项
  getExportOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0fyqpsu0pqujpot', 'put', config),
  // 小样导出
  putExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0fyqpsu', 'put', config),
  // 获取制作人员列表
  getMakers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0qjdnblf0qbqfs0vtfst', 'get', config),
  // getMakers: (config) =>
  // createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0qipupt0nblf0vtfst', 'get', config),
  // 查询所有修改痕迹
  getTraceAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0wfstjpo0usbdf0bmm', 'get', config),
  getTraceUsersAlternate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config
    ),
  getTraceUsersSame: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  getTraceSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config
    ),

  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0gjut0bsujdmft0efubjm', 'get', config),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0gjut0bsujdmft0efubjm', 'get', config),
  getImageInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0efubjm', 'get', config),
  // 小样重稿-获取文章相似稿列表
  getSimilarList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjnjmbs0mjtuebub', 'get', config),
  // 小样重稿-获取文章相似稿详情
  getSimilarDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjnjmbs0efubjm', 'get', config),
  // 小样重稿-获取文章相似稿详情
  CheckWholeRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0difdlXipmfSfwplf',
      'POST',
      config
    ),
  // 小样重稿-获取小样列表配置
  getE5Definition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60mjtut0efgjojujpo', 'get', config),
  // 小样重稿-保存小样列表配置
  postE5Definition: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60mjtut0efgjojujpo', 'POST', config),
  // 小样批量下载
  postDocBatchDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0epdCbudiEpxompbe',
      'POST',
      config,
      {
        timeout: 900000
      }
    )
}
